import { useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { User as TUser } from 't2-graphql-types';
import UsersListModalContent from '../UsersListModal/UsersListModalContent';
import { getUsersWhoLikedCommentByCommentIdQuery } from './queries/getUsersWhoLikedCommentByCommentId';
import Spinner from '../Spinner/Spinner';

type TCommentInteractionsModalContentProps = {
  isOpen: boolean;
  commentId: string;
};

export const CommentInteractionsModalContent = ({ isOpen, commentId }: TCommentInteractionsModalContentProps) => {
  const [getUsersWhoLikedComment, { data: t2UsersWhoLikedComment, loading: t2UsersWhoLikedCommentLoading }] =
    useLazyQuery(getUsersWhoLikedCommentByCommentIdQuery, {
      fetchPolicy: 'network-only',
    });

  useEffect(() => {
    if (isOpen) {
      getUsersWhoLikedComment({ variables: { commentId } });
    }
  }, [isOpen]);

  const usersWhoLikedComment = t2UsersWhoLikedComment?.comment?.likes || ([] as (TUser & { timestamp: string })[]);

  if (t2UsersWhoLikedCommentLoading) {
    return (
      <div className="flex items-center justify-center h-full w-full">
        <Spinner />
      </div>
    );
  }

  if (usersWhoLikedComment.length === 0) {
    return null;
  }

  return <UsersListModalContent usersList={usersWhoLikedComment} totalCount={usersWhoLikedComment.length} />;
};
